require('jquery.maskedinput/src/jquery.maskedinput.js');

export default () => {

  $('.ocf-option-name').on('click', function () {
    $(this).parent('.list-group-item').toggleClass('hide');
  })

  $('.contacts__point-title').on('click', function () {
    if (!$(this).parents('.contacts__point').hasClass('active')) {
      $('.contacts__point').removeClass('active');
    }
    $(this).parents('.contacts__point').toggleClass('active');
    if ($(window).width() < 767) {
      $('html, body').animate({
        scrollTop: $(this).offset().top - 82
      }, 1000);
    }
  });

  if ($(window).width() < 1200) {
    if ($('.news__nav').length) {
      const prev = $('.news__nav a.active').parent('li').prevAll();
      var totalSum = 0;
      for (var i = 0; i < prev.length; i++) {
        totalSum += Number(prev[i].clientWidth + 40);
      }
      $(".news__nav").scrollLeft(totalSum);
    }
    if ($('.js-product-card-tabs').length) {
      $('.js-product-card-tabs').insertBefore($('.js-container-product-card'));
      $(".js-product-card-tabs ul a").on("click", function () {
        const prev = $(this).parent('li').prevAll();
        var totalSum = 0;
        for (var i = 0; i < prev.length; i++) {
          totalSum += Number(prev[i].clientWidth + 40);
        }
        $(".js-product-card-tabs").scrollLeft(totalSum);

        if ($('.product-card__body').length != 0) {
          $('html, body').animate({
            scrollTop: $('.product-card__body').offset().top - 92
          }, 1000);
        }
      });
    }
  }

  $('.product-card__canvas-drop-current').on('click', function (event) {
    event.stopPropagation();
    $(this).parents('.product-card__canvas-drop').toggleClass('active');
  })

  $(document).on("click touchend", (event) => {
    event.stopPropagation();
    if ($(event.target).closest(".product-card__canvas-drop").length) return;
    $('.product-card__canvas-drop').removeClass('active');
  });

  $('.tabs-list--select a').on('click', function() {
    const title = $(this).text();
    $('.product-card__canvas-drop-current').text(title)
    $('.product-card__canvas-drop').removeClass('active');
  })

  $('.product-card__opening-system-item input[type=radio]').on('click', function () {
    const nameSystem = $(this).attr('system-name');
    $(this).parents('.product-card__opening-system').find('.product-card__opening-system-value').text(nameSystem)
  })

  $('.product-card__colors-item input[type=radio]').on('click', function () {
    const nameColor = $(this).attr('color-name');
    $(this).parents('.product-card__colors').find('.product-card__colors-value').text(nameColor)
  })

  $('.product__colors').each(function(index, element) {
    const fistInput = $(element).find('.product__colors-item')[0];
    $(fistInput).find('input[type=radio]').prop("checked", true);
  })
  
  $(document).on('click ', '.product__colors-item input[type=radio]', function() {
    const imgUrl = $(this).attr('data-src');
    $(this).parents('.product').find('.product__img img').attr('src', imgUrl)
  })

  $('.js-play-video').click(function (event) {
    event.stopPropagation();
    $('.js-video-parent').removeClass('video-play')
    $('.js-video-parent .our-salons__video-iframe iframe').remove();
    const videoId = $(this).attr('videoId');
    const videoFrame = `<iframe width="500" height="350" src="https://www.youtube.com/embed/${videoId}?autoplay=1" frameborder="0" allowfullscreen></iframe>`;
    $(this).parent('.js-video-parent').addClass('video-play').find('.our-salons__video-iframe').html(videoFrame);
  });

  $(document).on("click touchend", (event) => {
    event.stopPropagation();
    if ($(event.target).closest(".js-video-parent").length) return;
    $('.js-video-parent').removeClass('video-play')
    $('.js-video-parent .our-salons__video-iframe iframe').remove();
  });

  $('.menu-item-has-children > a').on('click', function () {
    $(this).siblings('.sub-menu-holder').addClass('active');
    return false;
  })

  $('.sub-menu-mobile-btn').on('click', function () {
    $('.sub-menu-holder').removeClass('active');
  })

  $('.header__mobile-catalog-btn').on('click', function () {
    $('.header__bottom').addClass('active');
  })
  
  $('.header__bottom-mobile-btn').on('click', function () {
    $('.header__bottom').removeClass('active');
  })

  $('.header__mobile-btn').on('click', function() {
    if ($(this).hasClass('active')) {
      $(this).toggleClass('active');
      $('.header__mobile-box').toggleClass('active');
      setTimeout(() => {
        $('.header__mobile').toggleClass('active');
      }, 300);
    } else {
      $(this).toggleClass('active');
      $('.header__mobile').toggleClass('active');
      setTimeout(() => {
        $('.header__mobile-box').toggleClass('active');
      }, 100);
    }
  })

  $('.header__mobile-overlay').on('click', function () {
    $('.header__mobile-btn').removeClass('active');
    $('.header__mobile-box').toggleClass('active');
    setTimeout(() => {
      $('.header__mobile').removeClass('active');
    }, 300);
  })

  $('.js-scroll-top').click(function() {
    $('html, body').animate({
      scrollTop: 0
    }, 500);
  });

  if ($('.our-salons__file').length) {
    $(".our-salons__video-btn").on("click", function (event) {
      event.stopPropagation();
      if ($(this).parents('.our-salons__video').hasClass('active')) {
        $(this).parents('.our-salons__video').removeClass('active');
        $(this).siblings('.our-salons__file')[0].pause();
      } else {
        $(this).parents('.our-salons__video').addClass('active');
        $(this).siblings('.our-salons__file')[0].play();
      }
    });
    $(document).on('click touchend', function (event) {
      event.stopPropagation();
      $('.our-salons__file')[0].pause();
      $('.our-salons__video').removeClass('active');
    })
  }

  if ($('.our-salons__video').length) {
    const heightBtn = $('.our-salons__video').innerHeight();
    $('.our-salons__video-btn').css('width', heightBtn)
  }

  jQuery(function($) {
    $("input[type=tel]").mask("+9 (999) - 999 - 99 - 99", { autoclear: false });
  });

  $('.js-toggle-catalog').on('click', () => {
    $('.header__bottom').toggleClass('visible')
  })

  function headerScroll() {
    if ($(window).scrollTop() > 0) {
      $('.header').addClass('header--scroll');
    } else {
      $('.header').removeClass('header--scroll');
    }
  }

  if ($(window).width() > 1200) {
    headerScroll();
    $(window).scroll(() => {
      headerScroll();
      $('.header__bottom').removeClass('visible')
    });
  }

  $(".js-input").each(function (index, element) {
    if ($(element).val() !== "") {
      $(element).parents(".js-input-parent").addClass('active');
    }
  });
  $(document).on('focus load', '.js-input', function () {
    $(this).parents(".js-input-parent").addClass('active focus');
  });
  $(document).on('blur', '.js-input', function () {
    if (($(this).val() == '') || ($(this).val() == '+38 (0__) - ___ - __ - __')) {
      $(this).parents(".js-input-parent").removeClass('active');
    }
    $(this).parents(".js-input-parent").removeClass('focus');
  });

}



// WEBPACK FOOTER //
// app/scripts/components/custom.js